import React from 'react';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import { withLocalePrefix } from 'shared/utils/translation';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { Body } from '@grnhse/seedling/lib/birch/typography';

const t = withLocalePrefix('talent_matching.modals.calibration_nudge');

type Props = {
  isOpen: boolean;
  onClose: () => void;
  canCreateCalibrationSetting: boolean;
  openCalibrationModal: () => void;
};

const CalibrationNudgeModal = ({
  isOpen,
  onClose,
  canCreateCalibrationSetting,
  openCalibrationModal,
}: Props) => {
  const onSubmit = () => {
    onClose();
    openCalibrationModal();
  };

  return (
    <DataEntryModal
      isOpen={isOpen}
      onDismiss={onClose}
      ariaLabel={t('header')}
      size="medium"
    >
      <DataEntryModal.Header onClick={onClose}>
        {t('header')}
      </DataEntryModal.Header>

      <DataEntryModal.Body>
        <Body>{t('description')}</Body>
        <Body>
          {canCreateCalibrationSetting
            ? t('review_calibration')
            : t('team_review')}
        </Body>
      </DataEntryModal.Body>

      <DataEntryModal.Footer>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          {canCreateCalibrationSetting && (
            <>
              <SecondaryButton onClick={onClose}>
                {t('actions.go_back')}
              </SecondaryButton>
              <PrimaryButton onClick={onSubmit}>
                {t('actions.review_calibration')}
              </PrimaryButton>
            </>
          )}
          {!canCreateCalibrationSetting && (
            <PrimaryButton onClick={onClose}>
              {t('actions.got_it')}
            </PrimaryButton>
          )}
        </Stack>
      </DataEntryModal.Footer>
    </DataEntryModal>
  );
};

export default CalibrationNudgeModal;
